import {BehaviorSubject, Subject} from "rxjs";
import {MenuCategoryData, MenuData, MenuItemData} from "./menu-entity.model";
import {MenuModel} from "./menu.model";

export class MenuCategorySelection {
    constructor(public category: MenuCategoryData,
                public reselected: boolean) {
    }
}

export class MenuItemSelection {
    constructor(public menuItem: MenuItemData,
                public category?: MenuCategoryData) {
    }
}

export class MenuEvents {

    /**
     * Sent by: MenuModel
     * Notifies the model for use in objects into which it cannot be injected (order items).
     */
    public static readonly menuModel: BehaviorSubject<MenuModel> = new BehaviorSubject(undefined);

    /**
     * Sent by: MenuModel
     * Notifies the current menu.
     */
    public static readonly currentMenu: BehaviorSubject<MenuData> = new BehaviorSubject(undefined);

    /**
     * Sent by: MenuModel
     * Notifies that the menu has been built or rebuilt.
     * The menu is based on the menu but also includes promoted categories.
     * The menu build also makes meta-data such as category mappings available via the menu model.
     */
    public static readonly menuBuilt$: Subject<void> = new Subject();

    /**
     * Sent by: MenuModel
     * Notifies that a category has been selected (or reselected after a reload).
     */
    public static readonly categorySelected$: BehaviorSubject<MenuCategorySelection> = new BehaviorSubject(new MenuCategorySelection(undefined, false));

    /**
     * Sent by: MenuModel
     * Notifies that a subcategory anchor has been selected.
     * The value indicates whether the selection was directly made by a user (true), or due to an anchor target scrolling into view (false).
     */
    public static readonly anchorSelected$: Subject<boolean> = new Subject();

    /**
     * Notifies that the menu items panel is scrolling
     */
    public static readonly itemsScrolling$: Subject<void> = new Subject();

    /**
     * Notifies that the subcategory anchor bar should be scrolled to the selected anchor.
     * Note that this event is separate to the selection of the anchor bar, since scrolling of the anchor bar doesn't occur
     * until the target items have finished scrolling.
     */
    public static readonly scrollAnchorBar$: Subject<number> = new Subject();

    /**
     * Sent by: MenuModel
     * Notifies that an activated promoted category has been added to the menu.
     */
    public static readonly activatedPromotedCategoryAdded$: Subject<MenuCategoryData> = new Subject();

    /**
     * Sent by: MenuModel
     * Notifies that a menu item initialisation request has been completed.
     */
    public static readonly menuItemInitialised$: Subject<MenuItemData> = new Subject();

    /**
     * Sent by: MenuModel
     * Notifies that an item order is waiting for the menu to load.
     */
    public static readonly itemOrderPending$: BehaviorSubject<boolean> = new BehaviorSubject(false);
}



// WEBPACK FOOTER //
// ./src/app/menu/menu-events.ts